import { UsersIcon } from "../../icons.js";
import type { WidgetProps } from "../types.js";

type FamilyHistoryPayload = {
  relation?: string;
  condition?: string;
  status?: string;
};

export function FamilyHistoryWidget({ events, onNavigate }: WidgetProps) {
  const entries = events.filter((e) => e.eventType === "family_history");

  const relatives = new Set(entries.map((e) => (e.payload as FamilyHistoryPayload).relation).filter(Boolean));
  const conditions = entries.map((e) => (e.payload as FamilyHistoryPayload).condition).filter(Boolean) as string[];
  const topConditions = [...new Set(conditions)].slice(0, 3);

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-2 flex items-center gap-2">
        <UsersIcon size={16} className="text-(--accent)" />
        <h2 className="font-semibold text-gray-900 dark:text-gray-100">Family history</h2>
        <button onClick={() => onNavigate("family-history")} className="ml-auto text-xs text-(--accent) hover:underline">
          View
        </button>
      </div>
      {entries.length === 0 ? (
        <p className="text-sm text-gray-400 dark:text-gray-500">No family history recorded</p>
      ) : (
        <div className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
          <div className="flex justify-between">
            <span>Relatives</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">{relatives.size}</span>
          </div>
          <div className="flex justify-between">
            <span>Conditions logged</span>
            <span className="font-medium text-gray-900 dark:text-gray-100">{conditions.length}</span>
          </div>
          {topConditions.length > 0 && (
            <div className="border-t border-gray-100 dark:border-gray-800 pt-2">
              <p className="mb-1 text-xs text-gray-500 dark:text-gray-400">Notable conditions</p>
              <ul className="space-y-0.5">
                {topConditions.map((c) => (
                  <li key={c} className="truncate text-xs text-gray-700 dark:text-gray-300">{c}</li>
                ))}
                {conditions.length > 3 && (
                  <li className="text-xs text-gray-400 dark:text-gray-500">+{conditions.length - 3} more</li>
                )}
              </ul>
            </div>
          )}
        </div>
      )}
    </section>
  );
}
